import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["header"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { Group } from './Group';
import { Item } from './Item';
import { Divider } from './Divider';
import styled from 'styled-components';
import { get } from '../../constants';
import { hasActiveDescendantAttribute } from '@primer/behaviors';
/**
 * Asserts that the given value fulfills the `GroupedListProps` contract.
 * @param props A value which fulfills either the `ListPropsBase` or the `GroupedListProps` contract.
 */

function isGroupedListProps(props) {
  return 'groupMetadata' in props;
}
/**
 * Contract for props passed to the `List` component.
 */


var StyledList = styled.div.withConfig({
  displayName: "List__StyledList",
  componentId: "sc-hkz3q0-0"
})(["font-size:", ";line-height:20px;&[", "],&:focus-within{--item-hover-bg-override:none;--item-hover-divider-border-color-override:", ";}"], get('fontSizes.1'), hasActiveDescendantAttribute, get('colors.border.muted'));
/**
 * Returns `sx` prop values for `List` children matching the given `List` style variation.
 * @param variant `List` style variation.
 */

function useListVariant() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'inset';

  switch (variant) {
    case 'full':
      return {
        headerStyle: {
          paddingX: get('space.2')
        },
        itemStyle: {
          borderRadius: 0
        }
      };

    default:
      return {
        firstGroupStyle: {
          marginTop: get('space.2')
        },
        lastGroupStyle: {
          marginBottom: get('space.2')
        },
        itemStyle: {
          marginX: get('space.2')
        }
      };
  }
}
/**
 * Lists `Item`s, either grouped or ungrouped, with a `Divider` between each `Group`.
 */


export var List = /*#__PURE__*/React.forwardRef(function (props, forwardedRef) {
  // Get `sx` prop values for `List` children matching the given `List` style variation.
  var _useListVariant = useListVariant(props.variant),
      firstGroupStyle = _useListVariant.firstGroupStyle,
      lastGroupStyle = _useListVariant.lastGroupStyle,
      headerStyle = _useListVariant.headerStyle,
      itemStyle = _useListVariant.itemStyle;
  /**
   * Render a `Group` using the first of the following renderers that is defined:
   * A `Group`-level or `List`-level custom `Group` renderer, or
   * the default `Group` renderer.
   */


  var renderGroup = function renderGroup(groupProps) {
    var _ref;

    var GroupComponent = ((_ref = 'renderGroup' in groupProps && groupProps.renderGroup) !== null && _ref !== void 0 ? _ref : props.renderGroup) || Group;
    return /*#__PURE__*/React.createElement(GroupComponent, _extends({}, groupProps, {
      key: groupProps.groupId
    }));
  };
  /**
   * Render an `Item` using the first of the following renderers that is defined:
   * An `Item`-level, `Group`-level, or `List`-level custom `Item` renderer,
   * or the default `Item` renderer.
   */


  var renderItem = function renderItem(itemProps, item, itemIndex) {
    var _ref2, _ref3, _itemProps$id; // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition


    var ItemComponent = 'renderItem' in itemProps && itemProps.renderItem || props.renderItem || Item;
    var key = (_ref2 = (_ref3 = 'key' in itemProps ? itemProps.key : undefined) !== null && _ref3 !== void 0 ? _ref3 : (_itemProps$id = itemProps.id) === null || _itemProps$id === void 0 ? void 0 : _itemProps$id.toString()) !== null && _ref2 !== void 0 ? _ref2 : itemIndex.toString();
    return /*#__PURE__*/React.createElement(ItemComponent, _extends({
      showDivider: props.showItemDividers,
      selectionVariant: props.selectionVariant
    }, itemProps, {
      key: key,
      sx: _objectSpread(_objectSpread({}, itemStyle), itemProps.sx),
      item: item
    }));
  };
  /**
   * An array of `Group`s, each with an associated `Header` and with an array of `Item`s belonging to that `Group`.
   */


  var groups = []; // Collect rendered `Item`s into `Group`s, avoiding excess iteration over the lists of `items` and `groupMetadata`:

  if (!isGroupedListProps(props)) {
    // When no `groupMetadata`s is provided, collect rendered `Item`s into a single anonymous `Group`.
    groups = [{
      items: props.items.map(function (item, index) {
        return renderItem(item, item, index);
      }),
      groupId: '0'
    }];
  } else {
    // When `groupMetadata` is provided, collect rendered `Item`s into their associated `Group`s.

    /**
     * A map of group identifiers to `Group`s, each with an associated array of `Item`s belonging to that `Group`.
     */
    var groupMap = props.groupMetadata.reduce(function (groupAccumulator, groupMetadata) {
      return groupAccumulator.set(groupMetadata.groupId, groupMetadata);
    }, new Map());

    var _iterator = _createForOfIteratorHelper(props.items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var itemProps = _step.value;

        var _group$items$length, _group$items, _group$items2; // Look up the group associated with the current item.


        var group = groupMap.get(itemProps.groupId);
        var itemIndex = (_group$items$length = group === null || group === void 0 ? void 0 : (_group$items = group.items) === null || _group$items === void 0 ? void 0 : _group$items.length) !== null && _group$items$length !== void 0 ? _group$items$length : 0; // Upsert the group to include the current item (rendered).

        groupMap.set(itemProps.groupId, _objectSpread(_objectSpread({}, group), {}, {
          items: [].concat(_toConsumableArray((_group$items2 = group === null || group === void 0 ? void 0 : group.items) !== null && _group$items2 !== void 0 ? _group$items2 : []), [renderItem(_objectSpread(_objectSpread({
            showDivider: group === null || group === void 0 ? void 0 : group.showItemDividers
          }, group && 'renderItem' in group && {
            renderItem: group.renderItem
          }), itemProps), itemProps, itemIndex)])
        }));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    groups = _toConsumableArray(groupMap.values());
  }

  return /*#__PURE__*/React.createElement(StyledList, _extends({}, props, {
    ref: forwardedRef
  }), groups.map(function (_ref4, index) {
    var header = _ref4.header,
        groupProps = _objectWithoutProperties(_ref4, _excluded);

    var hasFilledHeader = (header === null || header === void 0 ? void 0 : header.variant) === 'filled';
    var shouldShowDivider = index > 0 && !hasFilledHeader;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: groupProps.groupId
    }, shouldShowDivider ? /*#__PURE__*/React.createElement(Divider, {
      key: "".concat(groupProps.groupId, "-divider")
    }) : null, renderGroup(_objectSpread(_objectSpread({
      sx: _objectSpread(_objectSpread(_objectSpread({}, index === 0 && firstGroupStyle), index === groups.length - 1 && lastGroupStyle), index > 0 && !shouldShowDivider && {
        mt: 2
      })
    }, header && {
      header: _objectSpread(_objectSpread({}, header), {}, {
        sx: _objectSpread(_objectSpread({}, headerStyle), header.sx)
      })
    }), groupProps)));
  }));
});
List.displayName = 'ActionList';